import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import { Form } from "react-formio";
import { useParams, Link } from "react-router-dom";
import {
  getSurveyIndividualResponses,
  getIndSurveyRegionList,
  getIndSurveyCountriesList,
  getIndSurveyProfessionList,
} from "../../Utils/userFunctions";
import { Table, Modal } from "react-bootstrap";
import {
  get_Date,
  getSurveyStatusName,
  getDataArr,
} from "../../Utils/commonFunctions";
function SurveyIndividualResponsesView() {
  const [show, setShow] = useState(false);
  const [surveyData, setSurveyData] = useState("");
  const [surveyStatus, setSurveyStatus] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listRegions, setListRegions] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [listCountries, setListCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const [listProfession, setListProfession] = useState([]);
  const [selectedProfession, setSelectedProfession] = useState([]);
  const [participants, setParticipants] = useState("");
  const [individualData, setIndividualData] = useState("");
  const [formJson, setFormJson] = useState([]);
  const [dataJson, setDataJson] = useState([]);
  const { surveyID } = useParams();
  useEffect(() => {
    getSurveyParticipantIndividualResponses();
    getSurveyRegion();
  }, [pageNumber]);
  const getSurveyParticipantIndividualResponses = async () => {
    let bodyFormData = new FormData();
    let selectedRegionsArr = getDataArr(selectedRegions);
    let selectedCountriesArr = getDataArr(selectedCountries);
    let selectedProfessionArr = getDataArr(selectedProfession);
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("action", "filter");
    bodyFormData.append("region_filters", selectedRegionsArr);
    bodyFormData.append("country_filters", selectedCountriesArr);
    bodyFormData.append("profession_filters", selectedProfessionArr);
    bodyFormData.append("per_page", pageNumber);
    const response = await getSurveyIndividualResponses(bodyFormData);
    if (response.status == "success") {
      setTotalRecords(response.data[0].total_records);
      setSurveyData(response.data[0]);
      setParticipants(response.data[0].participants);
      setSurveyStatus(response.data[0].status);
      if (response.data[0].individualResult.length !== 0) {
        setIndividualData(response.data[0].individualResult);
        const filter1 = response.data[0].individualResult[0][
          "survey__form_json"
        ].replace(/"true"/g, "true"); // replace true
        const filter2 = filter1.replace(/"false"/g, "false"); // replace false
        const finalJson = filter2.replace(/"null"/g, "null"); // replace false
        const tmpData = JSON.stringify(
          response.data[0].individualResult[0]["attempted_data_json"]
        );
        const filterData1 = tmpData.replace(/"true"/g, "true"); // replace true
        const filterData2 = filterData1.replace(/"false"/g, "false"); // replace false
        const finalDataJson = filterData2.replace(/"null"/g, "null"); // replace false
        setFormJson(JSON.parse(finalJson));
        setDataJson(JSON.parse(finalDataJson));
      } else {
        setIndividualData("");
        setFormJson("");
        setDataJson("");
      }
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const getSurveyRegion = async () => {
    try {
      const response = await getIndSurveyRegionList(surveyID);
      setListRegions(response.optionItems);
    } catch (error) {
      setListRegions(null);
    }
  };
  const getCountryByRegion = async (regions) => {
    try {
      let bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(regions);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      const response = await getIndSurveyCountriesList(bodyFormData);
      setListCountries(response.optionItems);
    } catch (error) {
      setListCountries(null);
    }
  };

  const getProfessionByRegion = async (regions) => {
    try {
      let bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(regions);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      const response = await getIndSurveyProfessionList(bodyFormData);
      setListProfession(response.optionItems);
    } catch (error) {
      setListProfession(null);
    }
  };

  const getProfessionByRegionAndCountry = async (country) => {
    try {
      let bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(selectedRegions);
      let countrySelectedArr = getDataArr(country);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      bodyFormData.append("country", countrySelectedArr);
      const response = await getIndSurveyProfessionList(bodyFormData);
      setListProfession(response.optionItems);
    } catch (error) {
      setListProfession(null);
    }
  };
  const handleFilter = async () => {
    if (
      selectedRegions.length == 0 &&
      selectedCountries.length == 0 &&
      selectedProfession.length == 0
    ) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    } else {
      getSurveyParticipantIndividualResponses(1);
    }
  };
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };
  const handleNextClickPagination = (item) => {
    if (totalRecords > item) {
      setPageNumber(item + 1);
      getSurveyParticipantIndividualResponses();
    }
  };
  const handlePreviewClickPagination = (item) => {
    setPageNumber(item - 1);
    getSurveyParticipantIndividualResponses();
  };
  const previewDisabled = pageNumber <= 1 ? "disabled" : "";
  const nextDisabled = totalRecords > pageNumber ? "" : "disabled";
  return (
    <div>
      <UserHeader />
      <ToastContainer></ToastContainer>
      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header className="modal_custom_header text-center">
          <h5 className="text-white p-0 m-0">All Responses</h5>
        </Modal.Header>
        <Modal.Body>
          <Table bordered size="sm">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th className="text-center">Survey Name</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {participants.length > 0 ? (
                participants.map((row, i) => (
                  <tr key={++i}>
                    <td>
                      <span className="sno">{++i}</span>
                    </td>
                    <td>
                      {row.attempted_status === "1" ? (
                        <Link
                          to={
                            "/survey-form/participant-survey/" +
                            surveyID +
                            "/" +
                            row.participant_id
                          }
                        >
                          {row.participant__first_name}
                        </Link>
                      ) : (
                        row.participant__first_name
                      )}
                    </td>
                    <td>
                      {row.attempted_status === "1"
                        ? "Submitted"
                        : "Not Submitted"}
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <tr>
                    <td colSpan={3}>
                      {" "}
                      <div className="text-center">No records found</div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
      <div className="container">
        <div className="row mt-4">
          <div className="col-md-4">
            <div className="card vd-card">
              <div className="card-body">
                <div className="pmcf-content-info">
                  <span className="custom_survey_name">
                    {surveyData.survey_name}
                  </span>
                  <hr
                    style={{
                      border: "1px solid #006CB5",
                      borderRadius: 10,
                    }}
                  />

                  <div className="pmcf-survey-list" style={{ marginTop: "5%" }}>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Status</div>
                      <div className="pmcf-survey-value">
                        {getSurveyStatusName(surveyStatus)}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Launch Date</div>
                      <div className="pmcf-survey-value">
                        {surveyData.launch_date
                          ? get_Date(surveyData.launch_date)
                          : "Survey is yet to be launched"}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Completion Date</div>
                      <div className="pmcf-survey-value">
                        {get_Date(surveyData.completion_date)}
                      </div>
                    </div>
                  </div>
                  <div className="pmcf-survey-question-point">
                    <h2 style={{ color: "#006CB5" }}>
                      {" "}
                      {surveyData.no_of_question}
                    </h2>
                    <p style={{ color: "black" }}>QUESTIONS</p>
                  </div>
                  <div className="pmcf-survey-list">
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">
                        Number of Participants
                      </div>
                      <div className="pmcf-survey-value">
                        {" "}
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Responses</div>
                      <div className="pmcf-survey-value">
                        {surveyData.no_of_responses} /{" "}
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="card vd-card">
              <div className="card-body ind-response-list scrollbar-custom square thin">
                <div className="row">
                  <div className="col-md-6">
                    <Link
                      to={"#"}
                      className="btn btn-sm btn-primary custom-btn-primary"
                      onClick={() => {
                        handleShow();
                      }}
                    >
                      All Responses
                    </Link>
                  </div>

                  <div className="col-md-6 text-right">
                    <Link
                      to={"/UserSurveyDetails/" + surveyID}
                      className="btn btn-sm btn-primary custom-btn-primary"
                    >
                      <i className="fa fa-arrow-left"></i> Back
                    </Link>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-md-3 col-sm-12">
                    <span className="custom-label-font-weight">Region</span>
                    <MultiSelect
                      options={listRegions}
                      value={selectedRegions}
                      onChange={(e) => {
                        getCountryByRegion(e);
                        getProfessionByRegion(e);
                        setSelectedRegions(e);
                      }}
                      labelledBy="Select"
                    />
                  </div>
                  <div className="col-md-3 col-sm-12">
                    <span className="custom-label-font-weight">Country</span>
                    <MultiSelect
                      options={listCountries}
                      value={selectedCountries}
                      onChange={(e) => {
                        getProfessionByRegionAndCountry(e);
                        setSelectedCountries(e);
                      }}
                      labelledBy="Select"
                    />
                  </div>

                  <div className="col-md-3 col-sm-12">
                    <span className="custom-label-font-weight">Profession</span>

                    <MultiSelect
                      options={listProfession}
                      value={selectedProfession}
                      onChange={setSelectedProfession}
                      labelledBy="Select"
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <div className="form-group mt-4">
                      <button
                        className="btn btn-block custom-btn-primary btn-xs"
                        onClick={handleFilter}
                      >
                        Filter
                      </button>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3 m-auto">
                    {" "}
                    <Link
                      to={"#"}
                      className={
                        "btn btn-sm btn-md btn-lg btn_next_prev " +
                        previewDisabled
                      }
                      onClick={() => {
                        handlePreviewClickPagination(pageNumber);
                      }}
                    >
                      <i className="fa fa-arrow-left"></i> Previous
                    </Link>{" "}
                  </div>
                  <div className="col-md-6">
                    <div className="basic_info text-center mt-3">
                      <p className="mt-0"></p>
                      {individualData.length !== 0 ? (
                        <p>
                          Name –{" "}
                          {individualData[0]["first_name"] +
                            " " +
                            individualData[0]["last_name"]}
                          <br />
                          Region - {individualData[0]["region_name"]}
                          <br />
                          Country – {individualData[0]["country_name"]}
                          <br />
                          Profession – {individualData[0]["profession_name"]}
                        </p>
                      ) : (
                        <p className="text-center mt-0">
                          Sorry , no result found.
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3 text-right m-auto">
                    {" "}
                    <Link
                      to={"#"}
                      className={
                        "btn btn-sm btn-md btn-lg btn_next_prev " + nextDisabled
                      }
                      onClick={() => {
                        handleNextClickPagination(pageNumber);
                      }}
                    >
                      <i className="fa fa-arrow-right"></i> Next
                    </Link>{" "}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="query-card-body ind_resp">
                      <Form
                        src={{
                          display: "form",
                          components: formJson,
                        }}
                        submission={{
                          data: dataJson,
                        }}
                        options={{ readOnly: true }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SurveyIndividualResponsesView;
